
import { Placement } from '@post-office/placements-frontend/nav-4-projects-section';
export default Placement;
